import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  pin: {
    color: token.colorTextSecondary
  },
  pinned: {
    color: token.colorPrimary
  }
}))
